"use client";

import { OrganizationLogo } from "@saas/organizations/components/OrganizationLogo";
import { useState } from "react";
import { SignupStepEmail } from "./signup-steps/SignupStepEmail";
import { SignupStepOtp } from "./signup-steps/SignupStepOtp";
import { SignupStepPassword } from "./signup-steps/SignupStepPassword";

type Step = "email" | "otp" | "password";
const STEPS: Step[] = ["email", "otp", "password"];

interface SignupFormProps {
	prefillEmail?: string;
	invitationId?: string;
	organizationName?: string;
	organizationLogo?: string | null;
}

/** Create an account from an invitation: confirm the email, then name and password. */
export function SignupForm({
	prefillEmail,
	invitationId,
	organizationName,
	organizationLogo,
}: SignupFormProps) {
	const [step, setStep] = useState<Step>("email");
	const [email, setEmail] = useState(prefillEmail ?? "");
	const position = STEPS.indexOf(step);

	return (
		<div className="flex flex-col gap-6">
			<div className="flex items-center justify-between gap-3">
				{organizationName ? (
					<span className="flex min-w-0 items-center gap-2 text-sm">
						<OrganizationLogo
							name={organizationName}
							logoUrl={organizationLogo}
							className="size-6"
						/>
						<span className="truncate font-medium">
							{organizationName}
						</span>
					</span>
				) : (
					<span />
				)}
				<span className="flex items-center gap-1.5 text-muted-foreground text-xs">
					<span className="sr-only">
						Step {position + 1} of {STEPS.length}
					</span>
					{STEPS.map((item, index) => (
						<span
							key={item}
							aria-hidden
							className={
								index <= position
									? "h-1 w-5 rounded-full bg-brand"
									: "h-1 w-5 rounded-full bg-muted"
							}
						/>
					))}
				</span>
			</div>

			{step === "email" ? (
				<SignupStepEmail
					email={email}
					locked={!!prefillEmail}
					organizationName={organizationName}
					onSent={(sentTo) => {
						setEmail(sentTo);
						setStep("otp");
					}}
				/>
			) : step === "otp" ? (
				<SignupStepOtp
					email={email}
					onVerified={() => setStep("password")}
					onBack={() => setStep("email")}
				/>
			) : (
				<SignupStepPassword email={email} invitationId={invitationId} />
			)}
		</div>
	);
}
